<div class="btn-standard btn-standard-typo text-center px-3 py-2" [ngClass]="{ 'btn-black': useBlack, 'fixed-size': fixedSize }">
    <img *ngIf="icon !== ''" class="picto-medium me-2" src="{{ icon }}" />
    <ng-content></ng-content>
</div>